module.exports = "/build/web/svg/star-filled.2dfecadc14437f7d25d381044a049d25.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/star-filled.svg
// module id = 94
// module chunks = 24